import React, { cloneElement, ReactElement, useCallback, useState } from 'react';
import { SwitchTransition } from 'react-transition-group';
import { useTranslation } from '../../utils/useTranslation';
import { Drawer, DrawerContent } from '../feedback/Drawer';
import { Button } from '../input/Button';
import { Flex } from '../layout/Flex';
import { TransitionSlideUp } from '../transition/TransitionSlideUp';
import { Typography } from '../typography/Typography';
import { CollectionStatus, UserUI } from '../users/types';

interface CollectionStatusDrawerProps {
    handleClose: VoidFunction;
    handleEditName: VoidFunction;
    title: string;
    descriptionSlot?: ReactElement;
    status?: CollectionStatus;
    currentUser?: UserUI;
}

export const CollectionStatusDrawer = (props: CollectionStatusDrawerProps) => {
    const { handleClose, handleEditName, title, descriptionSlot, status, currentUser } = props;
    const [step, setStep] = useState<'OPEN' | 'CLOSE'>('OPEN');
    const onClose = useCallback(() => {
        setStep('CLOSE');
        handleClose();
    }, [handleClose]);
    const onEditName = useCallback(() => {
        setStep('CLOSE');
        handleEditName();
    }, [handleEditName]);
    const t = useTranslation();

    return (
        <SwitchTransition>
            <TransitionSlideUp key={step}>
                <Drawer onClose={onClose}>
                    <DrawerContent p={2} pt={0}>
                        <Typography variant="title3" weight="bold" py={2}>
                            {title}
                        </Typography>
                        {descriptionSlot && cloneElement(descriptionSlot)}
                        <Flex width="100%" spacing={1} py={2}>
                            {status === CollectionStatus.MODERATION && (
                                <Button color="primary" onClick={onClose} width="100%">
                                    {t('Хорошо')}
                                </Button>
                            )}
                            {status === CollectionStatus.DECLINED && (
                                <Button
                                    color="secondary"
                                    as="a"
                                    href={`${process.env.REACT_APP_BETA_SUPPORT_FORM_REGULAR_LINK}?login=${currentUser?.login}`}
                                    target="_blank"
                                    width="100%"
                                >
                                    {t('Обратиться в поддержку')}
                                </Button>
                            )}
                            {status === CollectionStatus.DECLINED && (
                                <Button onClick={onEditName} color="secondary" width="100%">
                                    {t('Отредактировать название')}
                                </Button>
                            )}
                            {status === CollectionStatus.DECLINED && (
                                <Button onClick={onClose} color="primary" width="100%">
                                    {t('Закрыть')}
                                </Button>
                            )}
                        </Flex>
                    </DrawerContent>
                </Drawer>
            </TransitionSlideUp>
        </SwitchTransition>
    );
};
